import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ImageBanner from "../components/ImageBanner";
import MenuSection from "../components/MenuSection";
import Gallery from "../components/Gallery";
import EventsCTA from "../components/EventsCTA";
import OpeningHours from "../components/OpeningHours";
import Footer from "../components/Footer";
import heroBurger from "../assets/hero-burger.jpg";


const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <HeroSection
        image={heroBurger}
        title="Riktiga hamburgare serverades från 2013 till 2025"
        subtitle="Vi öppnade våra dörrar 2013 med en passion för hamburgare — en fantastisk resa tillsammans med er. Nu har Burgersson stängt, men på samma plats har vi öppnat vårt nya koncept: BARLEYS FOOD FACTORY. Här fortsätter vi vår kärlek till lokala ölsorter och hamburgare gjorda på lokalt producerat kött och bröd — samma höga kvalitet ni känner igen, fast med nytt namn och modernare design."
        subtitle2={"Välkommen till en bekant smakupplevelse i ny skrud. För bordbokning eller frågor och för att upptäcka vår nya meny, vänligen klicka här."}
        buttons={[
          { label: "Lunch", href: "/lunch" },
          { label: "Takeaway", href: "/takeaway" },
          { label: "Större Sällskap / Företagsevent", href: "/events" },
        ]}
        id="hero"
      />
      <AboutSection />
      <ImageBanner />
      <MenuSection />
      <Gallery />
      <div id="events">
        <EventsCTA />
      </div>
      <OpeningHours />
      <Footer />
    </div>
  );
};

export default Index;
